declare module 'vue-router' {
  interface RouteMeta {
    pageTitle?: string;
    requiresAuth?: boolean;
  }
}

export enum RouteNames {
  APP_SHEL = 'App',
  HOME = 'Home',
  HELP = 'Help', // home/help/:type?
  DASHBOARD = 'Dashboard', // home/dashboard
  MY_ACCOUNT = 'MyAccount', // home/account
  DOMESTIC_VIOLENCE = 'DomesticViolence', // home/domesticviolence
  POLICY_DETAILS = 'PolicyDetails', // policy/details/:contractId
  GUIDANCE_CALCULATOR = 'GuidanceCalculator', // policy/guidance
  TERM_LIFE_BENEFITS = 'TermLifeBenefits', // policy/benefits
  INVESTMENTS = 'Investments',
  DEBT_SOLUTIONS = 'DebtSolutions',
  MY_DEBT = 'MyDebt',
  MY_PLAN = 'MyPlan',
  LEARN_MORE_DEBT = 'LearnMoreDebt',
  MY_REP = 'Representative',
  CHILD_RIDER = 'ChildRider',
  DOCUMENTS = 'Documents',
  DOCUMENT_LIST_MOBILE = 'DocumentListMobile',
  POLICY_DOCUMENTS = 'PolicyDocuments',
  NOTICES_AND_CONFIRMATIONS = 'NoticesAndConfirmations',
  INVESTMENT_STATEMENTS = 'InvestmentStatements',
  INVESTMENT_LEARN_MORE = 'InvestmentLearnMore',
  INVESTMENT_CALCULATOR = 'InvestmentCalculator',
  ALERT_AND_NOTIFICATIONS = 'AlertAndNotifications',
  POLICY_REINSTATEMENT = 'PolicyReinstatement',
  MINOR_ACCOUNT_LINK_PROCESS = 'MinorAccountLinkProcess',
  ABOUT = 'About',
  POST_LOGIN = 'PostLogin',
  PRE_LOGIN = 'PreLogin',
  LOGIN_SHELL = 'LoginShell',
  BOOTSTRAP_TASKS = 'BootstrapTasks',
  WIZARD_PAGES = 'WizardPages',
  BIOMETRICS_SPLASH = 'BiometricsSplash',
  POLICY_ACKNOWLEDGEMENT = 'PolicyAcknowledgementAction',
  TERMS_OF_USE = 'TermsOfUse',
  BENEFICIARY_STEP = 'BeneficiaryStep',
  PAYMENT_STEP = 'PaymentStep',
  WITHDRAWALDATESTEP = 'WithdrawalDatesStep',
  CHANGEBANKACCOUNTSTEP = 'ChangeBankAccountStep',
  PAYMETHODCHANGE = 'PayMethodChange',
  APP_UPDATE = 'AppUpdate',
  UNSUPPORTED_BROWSER = 'UnsupportedBrowser',
  MAINTENANCE_MODE = 'MaintenanceMode',
  POST_LOGOUT = 'PostLogout',
  LOGIN_LANDING_PAGE = 'LoginLandingPage',
  SUCCESS_BIOMETRICS = 'SuccessBiometrics',
  ERROR_BIOMETRICS = 'ErrorBiometrics',
  PAGE_NOT_FOUND = 'PageNotFound',
  ERROR = 'Error',
  ERROR_LAYOUT = 'ErrorLayout',
}
